'use client';

import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './inlineCollection.module.css';

interface InlineMetaLineProps {
	icon?: LucideIcon;
	children: ReactNode;
	className?: string;
}

export function InlineMetaLine({ icon: Icon, children, className }: InlineMetaLineProps) {
	return (
		<span className={`${styles.inlineMetaLine}${className ? ` ${className}` : ''}`}>
			{Icon ? <Icon size={12} aria-hidden="true" className={styles.inlineMetaIcon} /> : null}
			<span>{children}</span>
		</span>
	);
}
